import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setToast } from "../../../../app/appSlice";
import { useAppSelector } from "../../../../hooks/hooks";
import {
  extendedApi,
  IDomaine,
  useDeleteDomaineMutation,
  useDomainesQuery,
} from "../../cdsApiSlice";
import { setDomainePagination } from "../../cdsSlice";

interface IDeleteDomaine {
  domaine: IDomaine;
  visibleDialog: boolean;
  closeDialog: () => void;
}

const DeleteDomaine = ({
  domaine,
  visibleDialog,
  closeDialog,
}: IDeleteDomaine) => {

  const [deleteDomaine, deleteDomaineStatus] = useDeleteDomaineMutation();
  const dispatch = useDispatch();
  const pagination = useAppSelector((state) => state.cds.domainePagination)
  const { data: domains, ...DomainStatus } = useDomainesQuery(pagination);



  const footerDialog = () => {
    return (
      <>
        <Button
          label={"ANNULER"}
          onClick={() => closeDialog()}
          className="mr-3 p-button-outlined p-button-sm"
        />

        <Button
          id="hook-form"
          onClick={async () => {
            try {
              await deleteDomaine({ id: domaine.id }).unwrap();
              dispatch(
                setToast({
                  title: "Suppression d'un domaine",
                  severity: "success",
                  content: `Domaine ${domaine.libelle} supprimé !`,
                  life: 3000,
                })
              );
              closeDialog()
              if (domains?.data.length === 1 && pagination.page >= 1) {
                dispatch(
                  setDomainePagination({
                    ...pagination,
                    page: pagination.page - 1,
                  })
                );
              } else {
                DomainStatus.refetch();
              }
            } catch (e : any){
              let message = `Echec de la suppression du domaine ${domaine.libelle} !`
              if (e.data?.message?.includes("delete.domaine.sources")) {
                message = `Echec de la suppression du domaine ${domaine.libelle}: Il reste un process pour ce domaine dans Nifi.`
              }
        
              dispatch(
                setToast({
                  title: "Suppression d'un domaine",
                  severity: "error",
                  content: message,
                  life: 3000,
                })
              );
            }
          }}
          type="submit"
          label={"SUPPRIMER"}
          className="p-button-danger p-button-sm"
        >
          {deleteDomaineStatus.isLoading ? (
            <FontAwesomeIcon className="ml-2" icon="spinner" spin />
          ) : null}
        </Button>
      </>
    );
  };

  return (
    <>
      <Dialog
        header={`Supprimer un domaine`}
        footer={footerDialog}
        visible={visibleDialog}
        style={{ width: "25vw" }}
        modal
        onHide={() => {
          closeDialog();
        }}
      >
        <div className="mb-3">
          Etes-vous sûr de vouloir supprimer le domaine{" "}
          <span className="font-bold">{domaine.libelle}</span> ?
        </div>
      </Dialog>
    </>
  );
};

export default DeleteDomaine;
